let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("jaTPo"), load("jSJrn")]).then(() => parcelRequire('33aqb'));